import * as React from "react";

import { cn } from "@/lib/utils";

interface IconProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Material Symbols (Rounded) ligature name, e.g. `arrow_forward`. */
  name: string;
  /** Render the filled glyph (FILL axis 1) instead of the outlined default. */
  filled?: boolean;
}

/**
 * A single Material Symbols (Rounded) glyph — the site-wide icon primitive.
 *
 * Size is the element's `font-size`: pass a `text-[…]` utility to override the
 * 24px default (e.g. `text-[16px]` to match a former `h-4 w-4` lucide icon).
 * Colour follows `currentColor`, so `text-clarus-dark` and friends just work.
 * Decorative by default (`aria-hidden`); pass `role="img"` + `aria-label` and
 * `aria-hidden={false}` for a meaningful icon.
 */
export function Icon({ name, filled, className, ...props }: IconProps) {
  return (
    <span
      aria-hidden="true"
      translate="no"
      className={cn("ms-icon text-[24px]", filled && "is-filled", className)}
      {...props}
    >
      {name}
    </span>
  );
}
